import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { UpgradePage } from './upgrade';
import { SharedModule } from '../../../shared';
import { TranslateModule } from '@ngx-translate/core';
import { ActiveSubscriptionComponent } from './components/active-subscription.component';
import { UpgradeOptionsComponent } from './components/upgrade-options.component';
import { translateConfig } from '../../config/translate.config';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    UpgradePage,
    ActiveSubscriptionComponent,
    UpgradeOptionsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule.forChild([{ path: '', component: UpgradePage }]),
    TranslateModule.forChild(translateConfig),
    SharedModule
  ]
})
export class UpgradePageModule {}
